import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Navbar from '@/components/feature/Navbar'
import Footer from '@/components/feature/Footer'

const ABOUT_FORM_URL = 'http://tenford.cn/'

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const stats = [
    { value: '10,000+', label: '部签约作品', icon: 'ri-book-open-line' },
    { value: '500万', label: '日活读者', icon: 'ri-user-heart-line' },
    { value: '200+', label: '合作画师', icon: 'ri-brush-line' },
    { value: '99.8%', label: '读者好评率', icon: 'ri-thumb-up-line' },
  ]

  const milestones = [
    { year: '2023', title: '平台创立', desc: '韩漫漫画网站在首尔正式成立，获得首批100部韩漫正版授权。' },
    { year: '2024', title: '快速发展', desc: '签约作品突破5000部，日活读者突破100万，成为中文市场韩漫阅读首选平台。' },
    { year: '2025', title: '行业标杆', desc: '签约作品超过10000部，与韩国TOP10漫画平台全部建立合作，日活读者达到500万。' },
  ]

  return (
    <>
      <Navbar />

      <main>
        <section className="pt-24 pb-12 bg-background-50">
          <div className="max-w-[1000px] mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors duration-200 cursor-pointer">首页</Link>
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-s-line"></i>
              </span>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>

            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">
                关于韩漫漫画网站
              </h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                汇聚韩国顶级漫画作品的正版阅读平台，致力于为中国读者提供最优质的韩漫阅读体验
              </p>
            </div>
          </div>
        </section>

        <section className="py-12 bg-background-50" aria-labelledby="brand-intro-title">
          <div className="max-w-[1000px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
              <div>
                <h2 id="brand-intro-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  品牌介绍
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  韩漫漫画网站成立于2023年，是一家专注于韩国漫画正版引进与中文翻译的数字阅读平台。我们致力于打破语言壁垒，将韩国最优秀的漫画作品带给中国读者。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  我们的团队由漫画爱好者、专业翻译人员和资深技术工程师组成。核心翻译团队均拥有韩语高级水平认证和丰富的漫画翻译经验，确保每一部作品的翻译既准确传达原作精神，又符合中文读者的阅读习惯。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  目前，我们已经与包括Kakao Page、Naver Webtoon、Lezhin Comics等在内的韩国顶级漫画平台建立了深度合作关系，拥有超过一万部作品的官方授权，是国内韩漫品类最全、更新最快的阅读平台。
                </p>
              </div>
              <div className="relative rounded-3xl overflow-hidden" style={{ height: '380px' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20publisher%20office%20with%20bookshelves%20full%20of%20comics%2C%20warm%20lighting%2C%20creative%20workspace%2C%20modern%20interior%2C%20cozy%20reading%20corner%2C%20plants%2C%20wooden%20furniture%2C%20clean%20aesthetic%2C%20editorial%20photography%20style%2C%20soft%20natural%20light&width=800&height=760&seq=about-brand-01&orientation=portrait"
                  alt="韩漫漫画网站办公环境"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 bg-background-100" aria-labelledby="stats-title">
          <div className="max-w-[1000px] mx-auto px-4 md:px-6">
            <h2 id="stats-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
              平台数据
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/50">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className={`${stat.icon} text-lg`}></i>
                  </span>
                  <p className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-1">{stat.value}</p>
                  <p className="text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-12 space-y-6">
              <h3 className="font-heading text-xl font-bold text-foreground-950 text-center mb-8">发展历程</h3>
              <div className="relative">
                <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300 hidden md:block"></div>
                {milestones.map((m, i) => (
                  <div key={m.year} className="flex flex-col md:flex-row gap-4 md:gap-8 mb-8 last:mb-0">
                    <div className="flex items-center gap-3 md:w-[180px] shrink-0">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-bold shrink-0">
                        {m.year}
                      </span>
                      <h4 className="md:hidden font-heading text-lg font-bold text-foreground-900">{m.title}</h4>
                    </div>
                    <div className="flex-1 bg-background-50 rounded-2xl p-5 border border-background-200/50 ml-[52px] md:ml-0">
                      <h4 className="hidden md:block font-heading text-lg font-bold text-foreground-900 mb-1">{m.title}</h4>
                      <p className="text-sm text-foreground-600 leading-relaxed">{m.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 bg-background-50" aria-labelledby="contact-title">
          <div className="max-w-[1000px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <h2 id="contact-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  商务合作
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  我们欢迎各类商务合作，包括但不限于：内容授权合作、广告投放、品牌联名、IP开发等。如果您有合作意向，请通过以下方式与我们取得联系。
                </p>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 shrink-0">
                      <i className="ri-mail-line"></i>
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">商务邮箱</p>
                      <p className="text-sm text-foreground-500">hello@tenford.cn</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 shrink-0">
                      <i className="ri-phone-line"></i>
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">联系电话</p>
                      <p className="text-sm text-foreground-500">+82 2-1234-5678（首尔总部）</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 shrink-0">
                      <i className="ri-map-pin-line"></i>
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">公司地址</p>
                      <p className="text-sm text-foreground-500">韩国首尔特别市麻浦区弘益路5街 22-7，韩漫文化大楼 3F</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-heading text-xl font-bold text-foreground-950 mb-4">发送合作咨询</h3>
                <form
                  className="space-y-4"
                  action={ABOUT_FORM_URL}
                  method="POST"
                  onSubmit={(e) => {
                    e.preventDefault()
                    const form = e.currentTarget as HTMLFormElement
                    const formData = new FormData(form)
                    const honeypot = (formData.get('phone_alt') as string || '').trim()
                    if (honeypot) return
                    fetch(ABOUT_FORM_URL, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                    }).then(async (res) => {
                      const text = await res.text()
                      const parsed = JSON.parse(text)
                      if (res.ok && parsed?.code === 'OK') {
                        form.reset()
                      }
                    }).catch(() => {})
                  }}
                >
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-600 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                        placeholder="您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-company" className="block text-xs font-medium text-foreground-600 mb-1.5">公司名称</label>
                      <input
                        id="contact-company"
                        name="company"
                        type="text"
                        className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                        placeholder="公司名称"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-600 mb-1.5">邮箱</label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                      placeholder="hello@tenford.cn"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-xs font-medium text-foreground-600 mb-1.5">合作类型</label>
                    <select
                      id="contact-subject"
                      name="subject"
                      className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      <option value="">请选择合作类型</option>
                      <option value="content">内容授权合作</option>
                      <option value="advertising">广告投放</option>
                      <option value="brand">品牌联名</option>
                      <option value="ip">IP开发</option>
                      <option value="other">其他合作</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-600 mb-1.5">合作说明</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200 resize-none"
                      placeholder="请简要描述合作意向（500字以内）"
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="w-full py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-xl hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    发送咨询
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 bg-background-100" aria-labelledby="reputation-title">
          <div className="max-w-[1000px] mx-auto px-4 md:px-6">
            <h2 id="reputation-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
              读者口碑
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[
                { name: '漫画爱好者小王', text: '自从发现韩漫漫画网站，我每天的追更生活就停不下来了。更新速度真的快，翻译也很用心，强烈推荐！', rating: 5 },
                { name: '资深漫迷小李', text: '分类特别清晰，找漫画超方便。画质高清，阅读体验非常好。周榜推荐每次都给我种草新作品。', rating: 5 },
                { name: '上班族小张', text: '午休时间必刷的网站！免费内容就很丰富了，评论区也很有趣，感觉找到了组织。', rating: 5 },
              ].map((review) => (
                <div key={review.name} className="bg-background-50 rounded-2xl p-6 border border-background-200/50">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }, (_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">&ldquo;{review.text}&rdquo;</p>
                  <p className="text-xs font-semibold text-foreground-900">— {review.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: '关于韩漫漫画网站',
        description: '韩漫漫画网站品牌介绍、平台数据、商务合作联系方式',
        url: 'http://tenford.cn/about',
        isPartOf: {
          '@type': 'WebSite',
          name: '韩漫漫画网站',
          url: 'http://tenford.cn/',
        },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://tenford.cn/' },
            { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://tenford.cn/about' },
          ],
        },
      })}} />
    </>
  )
}